var render, staticRenderFns
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src696773760/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/685534022793/ap-northeast-1/04f8861f-389a-48e5-bae0-9e3baa814fbd/lvgs/project-LPMT/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c131c7')) {
      api.createRecord('63c131c7', component.options)
    } else {
      api.reload('63c131c7', component.options)
    }
    
  }
}
component.options.__file = "resources/views/common/object/component/form/elementLp1/stepGroup/component.vue"
export default component.exports